export enum PromptUserAction {
  apply = 'apply',
  abort = 'abort',
  skip = 'skip',
}

export interface PromptActionPayload {
  modalId: PromptModals;
  type: PromptUserAction;
}

export enum PromptModals {
  reassignAgentManagerModal = 'reassignAgentManagerModal',
  reassignAgencyManagerModal = 'reassignAgencyManagerModal',
  manageAgentTeammates = 'manageAgentTeammates',
}
